<div mat-dialog-content>
	<div class="weather-station-container">
		<div class="left-content-container bk-modal__left bk-weather-stations-left">
			<div *ngIf="showWeatherStationsList">
				<div class="bk-warning-text--weather_stations"
					*ngIf="zoomOutWarning">
					{{'Zoom Out Warning Text' | translate }}.
				</div>
				<label class="bk-weather-station"
					*ngFor="let station of weatherStations">
					<input [checked]="station.Selected"
						class="bk-modal__checkbox--left"
						type="checkbox"
						(click)="selectStation(station)"/>

					<span class="bk-modal__label-text">
						<span class="bk-bold bk-weather-station__name">
							{{station.Name}} <ng-container *ngIf="station.External_Id">(#{{station.External_Id}})</ng-container>
						</span>

						<span *ngIf="station.Distance !== null && station.Distance !== undefined">
							{{station.Distance}} {{'miles' | translate }}
							<ng-container *ngIf="station.NearestCity || station.County">
								- {{station.NearestCity}}, {{station.County}}
							</ng-container>
						</span>
					</span>
				</label>
			</div>
		</div>
		<div class="bk-modal__right bk-weather-stations-right">
			<div class="bk-modal__right-instructions">
				{{'Weather Station Instruction Text' | translate }}
			</div>
			<div class="bk-modal__right-instructions">
				<div class="bk-marker bk-marker--ranch">
					<svg-ranch-marker></svg-ranch-marker>
				</div>
				{{'Ranch Location' | translate }}
				<div class="bk-marker bk-marker--unselected">
					<svg-station-location></svg-station-location>
				</div>
				{{'Unselected Station' | translate }}
				<div class="bk-marker bk-marker--selected">
					<svg-station-location></svg-station-location>
				</div>
				{{'Selected Station' | translate }}
			</div>
			<div *ngIf="!ranchLocation"
				class="bk-modal__warning-section">
				<mat-icon>warning</mat-icon>Ranch coordinates are missing. Edit the ranch to
				update ranch coordinates.
			</div>
			<div class="map-container bk-modal__map-container">
				<agm-map (boundsChange)="resetMapOnboundsChange($event)"
					[mapTypeId]="'hybrid'"
					[fullscreenControl]="true">

					<agm-marker *ngFor="let station of weatherStations"
						[iconUrl]="getStationMarker(station)"
						[latitude]="station.Latitude"
						[longitude]="station.Longitude"
						[label]="getStationId(station.External_Id)"
						(markerClick)="selectStation(station)">
					</agm-marker>

					<ng-container *ngIf="ranchLocation">
						<agm-marker
							[iconUrl]="'../assets/images/icons/map_marker-ranch-v2.png'"
							[latitude]="ranchLocation.Latitude"
							[longitude]="ranchLocation.Longitude">
						</agm-marker>
					</ng-container>
					<map-control></map-control>
				</agm-map>
			</div>
		</div>
	</div>
</div>
